import React from "react"
import htmlParser from "html-react-parser"
import { extractPhoneNumber, sanitizeDOMString } from "@/utils/helper"

const ChekoutErrorMessage = props => {
  const {
    customPaymentErrorMsg = "",
    genericPaymentErrorMsg = "",
    onLinkClick = () => {},
    paymentOption = "",
  } = props || {}

  return (
    <>
      {customPaymentErrorMsg
        ? htmlParser(sanitizeDOMString(customPaymentErrorMsg), {
            replace: domNode => {
              if (domNode.name === "a") {
                return (
                  <a
                    href={domNode.attribs.href}
                    onClick={e => {
                      onLinkClick(
                        e,
                        extractPhoneNumber(customPaymentErrorMsg),
                        paymentOption
                      )
                    }}
                    className={domNode.attribs.class}
                  >
                    {domNode.children[0].data}
                  </a>
                )
              }
            },
          })
        : genericPaymentErrorMsg}
    </>
  )
}

export default ChekoutErrorMessage
